enum ApplicationStatus {
    New = 'new',
    Engaged = 'engaged',
    Win = 'win',
    Lost = 'lost',
}

export default ApplicationStatus;
